import { Pagination, Skeleton, TablePagination } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Badge } from "@chakra-ui/react";
import { formatNumber } from 'utils';
import { useTranslation } from 'react-i18next';

export default function PaginateBox({ page, handleChange, count, total, rowsPerPage, handleChangeRowsPerPage, loading, compactMode=false }) {
  const { t } = useTranslation('paginate_box');

  return (
    <div className="flex justify-between rounded-md bg-gray-100 shadow py-0">
      {!compactMode && (
        <div className='flex flex-1 justify-center'>
          <Badge
            fontSize={15}
            rounded={5}
            padding={1}
            paddingInline={2}
            colorScheme="green"
            color={"black"}
          >
            {formatNumber(total) || 0}
          </Badge>
        </div>
      )}
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={handleChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[25, 50, 75, 100, 200, 500, 750, 1000, 2000, 5000, 10000]}
        labelRowsPerPage={compactMode ? "" : t("label_rows_per_page")}
        labelDisplayedRows={({ from, to, count }) => t("label_displayed_rows", {
          page: page + 1,
          from,
          to,
          count: count !== -1 ? count : t("more_than", { to })
        })}
        lang='fr'
        showFirstButton={true}
        showLastButton={true}
      />
    </div>
  );
}